import { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  // Steps,
  Switch,
  Tabs, Table, Pagination
} from "antd";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import DashbordSidebar from "../../components/DashboardSidebar";
// import image1 from "../../assets/gloves.png";
// import { Post } from "../../config/api/post";
import { Put } from "../../config/api/put";
// import { DRIVER, RIDE, UPLOADS_URL } from "../../config/constants/api";
import swal from "sweetalert";
// import { extractTime, formatTime } from "../../config/helpers";
import { AiOutlineEye } from "react-icons/ai";
import dayjs from "dayjs";
import { Get } from "../../config/api/get";
import { BOOKING, CHAUFFEUR, FARE, RATES } from "../../config/constants/api";
import { extractTime } from "../../config/helpers";
import moment from "moment/moment";
// import ReviewModal from "../../components/ReviewModal";
import { addUser } from "../../redux/slice/authSlice";

// import { Get } from "../../config/api/get";
// import ReviewModal from "../../components/ReviewModal";
// const { Step } = Steps;

const DropzoneFiltercards = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  console.log("loading", loading);
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const index = location?.state?.index;
  const [latestRates, setLatestRates] = useState(null);
  const navigate = useNavigate();
  const [latestFares, setLatestFares] = useState(null);
  console.log("latestFares", latestFares);
  // const [bookings, setBookings] = useState([]);
  const [requestedBookings, setRequestedBookings] = useState([]);
  const [upcomingBookings, setUpcomingBookings] = useState(null);
  const [tabIndex, setTabIndex] = useState("2");
  const [isOnline, setIsOnline] = useState(userData.isOnline); // Initialize with the current state if available
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };
  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
  };
  const getAllLatestRates = () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getHourlyRate = (serviceType, passengerCapacity) => {
    if (latestRates) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          rate._id.passengerCapacity === passengerCapacity
      );
      return rate?.rate;
    }
  };
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;
  const getAllLatestFares = () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  // const getPerMileRate = (serviceType, passengerCapacity) => {
  //   if (latestFares && passengerCapacity) {
  //     let service = latestFares.find(
  //       (fare) =>
  //         fare._id.serviceType === serviceType &&
  //         fare._id.passengerCapacity === passengerCapacity
  //     );
  //     return service?.fare;
  //   }
  // };
  const formatinHours = (minutes) => {
    return minutes / 60;
  };
  // const columns = [
  //   {
  //     title: "S. No.	",
  //     dataIndex: "_id",
  //     key: "_id",
  //     width: 100,
  //     render: (value, item, index) => (index < 9 && "0") + (index + 1),
  //   },
  //   {
  //     title: "Date",
  //     dataIndex: "date",
  //     key: "date",
  //     render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
  //   },
  //   {
  //     title: "Time",
  //     dataIndex: "time",
  //     key: "time",
  //     render: (item) => <span>{extractTime(item)}</span>,
  //   },
  //   {
  //     title: "First Name",
  //     dataIndex: "user",
  //     key: "user",
  //     render: (item) => (item?.firstName ? item?.firstName : "-"),
  //   },
  //   {
  //     title: "Last Name",
  //     dataIndex: "user",
  //     key: "user",
  //     render: (item) => (item?.lastName ? item?.lastName : "-"),
  //   },
  //   {
  //     title: "Pk-up Address",
  //     dataIndex: ["pickupLocation", "address"],
  //     key: "address",
  //     render: (item) => (item?.length > 35 ? item?.slice(0, 35) + "..." : item),
  //   },
  //   {
  //     title: "Dr-off Address",
  //     dataIndex: ["dropoffLocation", "address"],
  //     key: "address",
  //     render: (item) =>
  //       item
  //         ? item?.length > 35
  //           ? item?.slice(0, 35) + "..."
  //           : item
  //         : "Unknown",
  //   },
  //   {
  //     title: "Car Type",
  //     dataIndex: "serviceType",
  //     key: "serviceType",
  //     render: (item) => <span>{item + " Luxury"}</span>,
  //   },
  //   {
  //     title: "Req Hours",
  //     dataIndex: "duration",
  //     key: "duration",
  //     render: (item) => <span>{item + " Hours"}</span>,
  //   },
  //   {
  //     title: "Discount",
  //     dataIndex: "-",
  //     key: "-",
  //     render: (item) => <span>{"00%"}</span>,
  //   },
  //   {
  //     title: "Rate",
  //     dataIndex: "",
  //     key: "rate",
  //     render: (item) => (
  //       <span>
  //         ${getHourlyRate(item?.serviceType, item?.passengerCapacity)}Hr
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "Amount",
  //     dataIndex: "",
  //     key: "rate",
  //     render: (item) => (
  //       <span>
  //         $
  //         {getHourlyRate(item?.serviceType, item?.passengerCapacity) *
  //           item?.duration}{" "}
  //         + per mile + overtime
  //       </span>
  //     ),
  //   },
  //   // {
  //   //   title: "Per mile + overtime",
  //   //   dataIndex: "",
  //   //   key: "-",
  //   //   render: (item) => (
  //   //     <span>
  //   //       $
  //   //       {getPerMileRate(item?.serviceType, item?.passengerCapacity)}
  //   //     </span>
  //   //   ),
  //   // },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     key: "status",
  //     render: (item) => (
  //       <>
  //         {item === "PENDING" ? (
  //           <span style={{ color: "#DD9F00" }}>{item}</span>
  //         ) : item === "UPCOMING" ? (
  //           <span style={{ color: "#2D308B" }}>{item}</span>
  //         ) : item === "ARRIVED" ? (
  //           <span style={{ color: "#2D308B" }}>{item}</span>
  //         ) : item === "ACCEPTED" ? (
  //           <span style={{ color: "#2D308B" }}>{item}</span>
  //         ) : item === "COMPLETED" ? (
  //           <span style={{ color: "#00D640" }}>{item}</span>
  //         ) : (
  //           <span>{item}</span>
  //         )}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Booking No",
  //     dataIndex: "_id",
  //     key: "_id",
  //     render: (item) => <span>#{item.slice(-4)}</span>,
  //   },
  //   {
  //     title: "Action",
  //     dataIndex: "_id",
  //     key: "_id",
  //     render: (value, item, index) => (
  //       <AiOutlineEye
  //         style={{ fontSize: "18px", color: "grey", cursor: "pointer" }}
  //         onClick={() =>
  //           navigate("completedBooking/" + value, { state: { id: item._id } })
  //         }
  //       />
  //     ),
  //   },
  // ];
  const columnsPending = [
    {
      title: "S. No.	",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (item) => <span>{extractTime(item)}</span>,
    },
    {
      title: "First Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.firstName ? item?.firstName : "-"),
    },
    {
      title: "Last Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.lastName ? item?.lastName : "-"),
    },
    {
      title: "Pk-up Address",
      dataIndex: ["pickupLocation", "address"],
      key: "address",
      render: (item) => (item?.length > 35 ? item?.slice(0, 35) + "..." : item),
    },
    {
      title: "Dr-off Address",
      dataIndex: ["dropoffLocation", "address"],
      key: "address",
      render: (item) =>
        item
          ? item?.length > 35
            ? item?.slice(0, 35) + "..."
            : item
          : "Unknown",
    },
    {
      title: "Car Type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (item) => <span>{item + " Luxury"}</span>,
    },
    {
      title: "Req Hours",
      dataIndex: "duration",
      key: "duration",
      render: (item) => <span>{item + " Hours"}</span>,
    },
    {
      title: "Discount",
      dataIndex: "-",
      key: "-",
      render: (item) => <span>{"00%"}</span>,
    },
    {
      title: "Rate",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          ${getHourlyRate(item?.serviceType, item?.passengerCapacity)}Hr
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          $
          {getHourlyRate(item?.serviceType, item?.passengerCapacity) *
            item?.duration}{" "}
          + per mile + overtime
        </span>
      ),
    },
    // {
    //   title: "Per mile + overtime",
    //   dataIndex: "",
    //   key: "-",
    //   render: (item) => (
    //     <span>
    //       $
    //       {getPerMileRate(item?.serviceType, item?.passengerCapacity)}
    //     </span>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "UPCOMING" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ARRIVED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ACCEPTED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "PAID" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: "Booking No",
      dataIndex: "_id",
      key: "_id",
      render: (item) => <span>#{item.slice(-4)}</span>,
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <AiOutlineEye
          style={{ fontSize: "18px", color: "grey", cursor: "pointer" }}
          onClick={() =>
            navigate("pendingBookings/" + value, { state: { data: item } })
          }
        />
      ),
    },
  ];
  const columnsUpcoming = [
    {
      title: "S. No.	",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (item) => <span>{moment.utc(item).format("hh:mm A")}</span>,
    },
    {
      title: "First Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.firstName ? item?.firstName : "-"),
    },
    {
      title: "Last Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.lastName ? item?.lastName : "-"),
    },
    {
      title: "Pk-up Address",
      dataIndex: ["pickupLocation", "address"],
      key: "address",
      render: (item) => (item?.length > 35 ? item?.slice(0, 35) + "..." : item),
    },
    {
      title: "Dr-off Address",
      dataIndex: ["dropoffLocation", "address"],
      key: "address",
      render: (item) =>
        item
          ? item?.length > 35
            ? item?.slice(0, 35) + "..."
            : item
          : "Unknown",
    },
    {
      title: "Car Type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (item) => <span>{item + " Luxury"}</span>,
    },
    {
      title: "Req Duration",
      dataIndex: "duration",
      key: "duration",
      render: (item) => (
        <span>
          {" "}
          {formatinHours(item) >= 1
            ? `${formatinHours(item)} Hours`
            : item + " Minutes"}
        </span>
      ),
    },
    {
      title: "Discount",
      dataIndex: "-",
      key: "-",
      render: (item) => <span>{"00%"}</span>,
    },
    {
      title: "Rate",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          ${getHourlyRate(item?.serviceType, item?.passengerCapacity)}Hr
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          $
          {item?.duration < 60
            ? (
                (item?.duration *
                  getHourlyRate(item?.serviceType, item?.passengerCapacity)) /
                60
              ).toFixed(2)
            : (
                getHourlyRate(item?.serviceType, item?.passengerCapacity) *
                (item?.duration / 60)
              ).toFixed(2)}{" "}
          + per mile + overtime
        </span>
      ),
    },
    // {
    //   title: "Per mile + overtime",
    //   dataIndex: "",
    //   key: "-",
    //   render: (item) => (
    //     <span>
    //       $
    //       {getPerMileRate(item?.serviceType, item?.passengerCapacity)}
    //     </span>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "UPCOMING" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ARRIVED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ACCEPTED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ENDED" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: "Booking No",
      dataIndex: "_id",
      key: "_id",
      render: (item) => <span>#{item.slice(-4)}</span>,
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <AiOutlineEye
          style={{ fontSize: "18px", color: "grey", cursor: "pointer" }}
          onClick={() =>
            navigate("/ride/" + value, { state: { id: item._id } })
          }
        />
      ),
    },
  ];
  const getMyUpcomingBooking = async () => {
    Get(BOOKING.getMyUpcomingBooking, token)
      .then((response) => {
        if (response?.status) {
          setUpcomingBookings(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
        }
      })
      .catch((err) => {
        console.log("Error Fetching Ongoing Booking", err);
      });
  };
  useEffect(() => {
    setTabIndex(index);
    if (index === "1" && isOnline) {
      getMyUpcomingBooking();
    } else if (index === "2" && isOnline) {
      getRequestedBookings();
    }
    // else if (index === "3") {
    //   getBookings(
    //     paginationConfig?.pageNumber,
    //     paginationConfig?.limit,
    //     "COMPLETED",
    //     userData?._id
    //   );
    // }
    // eslint-disable-next-line
  }, [index, isOnline]);
  const getOngoingBooking = async () => {
    Get(BOOKING.getChauffeurOngoingBooking, token)
      .then((response) => {
        if (response?.status) {
          navigate(`/ride/${response?.data?._id}`, {
            state: { id: response?.data?._id },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getOngoingBooking();
    if (tabIndex === "1") {
      getMyUpcomingBooking();
    } else if (tabIndex === "2") {
      getRequestedBookings();
    }
    // else if (tabIndex === "3") {
    //   getBookings(
    //     paginationConfig?.pageNumber,
    //     paginationConfig?.limit,
    //     "COMPLETED",
    //     userData?._id
    //   );
    // }
    getAllLatestRates();
    getAllLatestFares();
    // eslint-disable-next-line
  }, []);
  // const getBookings = async (pageNumber, pageSize, status, chauffeur) => {
  //   Get(BOOKING.getAllBookings, token, {
  //     page: pageNumber
  //       ? pageNumber.toString()
  //       : paginationConfig.pageNumber.toString(),
  //     limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
  //     status,
  //     chauffeur,
  //   })
  //     .then((response) => {
  //       if (response?.status) {
  //         setBookings(response?.data?.docs);
  //         setPaginationConfig({
  //           pageNumber: response?.data?.page,
  //           limit: response?.data?.limit,
  //           totalDocs: response?.data?.totalDocs,
  //           totalPages: response?.data?.totalPages,
  //         });
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log("Error fetching bookings ", err);
  //       setLoading(false);
  //     });
  // };
  const getRequestedBookings = async (pageNumber, pageSize) => {
    Get(BOOKING.getRequestedBookings, token, {
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.status) {
          setRequestedBookings(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching Requested Bookings ", err);
        setLoading(false);
      });
  };
  const onChange = (key) => {
    setTabIndex(key);
    if (Number(key) === 1) {
      getMyUpcomingBooking();
    }
    if (Number(key) === 2) {
      getRequestedBookings();
    }
    // else if (Number(key) === 3) {
    //   getBookings(
    //     paginationConfig?.pageNumber,
    //     paginationConfig?.limit,
    //     "COMPLETED",
    //     userData?._id
    //   );
    // }
  };
  const items = [
    {
      key: "1",
      label: "Upcoming Booking",
      children: (
        <>
          <Row style={{ padding: 20, overflow: "auto" }}>
            {Array.isArray(upcomingBookings) ? (
              <Table
                className="styledTable"
                dataSource={upcomingBookings}
                columns={columnsUpcoming}
                pagination={false}
              />
            ) : (
              <p style={{ fontWeight: "bold", margin: "50px auto" }}>
                No Upcoming Bookings to Show
              </p>
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p>{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "2",
      label: "Requested Booking",
      children: (
        <>
          <Row style={{ padding: 20, overflow: "auto" }}>
            <Table
              className="styledTable"
              dataSource={requestedBookings}
              columns={columnsPending}
              pagination={false}
            />
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p>{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </>
      ),
    },
    // {
    //   key: "3",
    //   label: "Completed Booking",
    //   children: (
    //     <>
    //       <Row style={{ padding: 20, overflow: "auto" }}>
    //         <Table
    //           className="styledTable"
    //           dataSource={bookings}
    //           columns={columns}
    //           pagination={false}
    //         />
    //       </Row>
    //       <Row style={{ padding: "10px 20px" }}>
    //         <Col xs={24} md={12}>
    //           <p>{message}</p>
    //         </Col>
    //         <Col
    //           xs={24}
    //           md={12}
    //           style={{
    //             display: "flex",
    //             justifyContent: "flex-end",
    //           }}
    //         >
    //           <Pagination
    //             className="styledPagination"
    //             onChange={(e) => handlePageChange(e)}
    //             current={parseInt(paginationConfig.pageNumber)}
    //             pageSize={paginationConfig.limit}
    //             total={paginationConfig.totalDocs}
    //             itemRender={itemRender}
    //           />
    //         </Col>
    //       </Row>
    //     </>
    //   ),
    // },
  ];

  const handleChange = (val) => {
    Put(CHAUFFEUR.toggleActivity, token)
      .then((response) => {
        if (response?.status) {
          swal("System Alert", response?.message, "success");
          dispatch(addUser({ user: response.data, token: token }));
          setIsOnline(!isOnline);
        }
      })
      .catch((e) => {
        let message = e?.response?.data?.message
          ? e?.response?.data?.message
          : e?.message;
        console.log(":::;", e);
        if (message) swal("Oops!", message, "error");
      });
  };
  return (
    <>
      <div className="shop-page">
        <Row style={{ width: "100%", justifyContent: "center" }}>
          <Col xs={23} md={21}>
            <div className="shop-page-main">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24} lg={24} xl={24}>
                  <div className="my-account-profile">
                    <section className="side-menu-parent">
                      <DashbordSidebar />
                      <div
                        className="about-us-section"
                        style={{ justifyContent: "center" }}
                      >
                        <div className="bg-paren" style={{ width: "100%" }}>
                          <Card
                            className="orderDetails"
                            style={{ padding: "20px 0" }}
                          >
                            <Row gutter={[16, 16]}>
                              <Col
                                lg={24}
                                md={24}
                                xs={24}
                                style={{
                                  textAlign: "end",
                                  marginBottom: "10px",
                                }}
                              >
                                <Switch
                                  checkedChildren="Online"
                                  unCheckedChildren="Offline"
                                  onChange={handleChange}
                                  checked={isOnline}
                                  // disabled={ongoingRide}
                                />
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={24}>
                                <Tabs
                                  activeKey={tabIndex}
                                  // defaultActiveKey={tabIndex}
                                  items={items}
                                  onChange={onChange}
                                />
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </div>
                    </section>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DropzoneFiltercards;
